import { Typography } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { useContext, useState } from 'react'

import { MinterAuctionContext } from '../../Contexts'
import { Property } from '../Property'

const BuyerProperty: React.FC = () => {
  const { auction } = useContext(MinterAuctionContext)

  const [buyerBidder, setBuyerBidder] = useState<EthAddress | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await auction?.getBidder()
      if (!isMounted()) return
      setBuyerBidder(data)
    },
    [auction],
  )

  return (
    <Property title="Buyer" value={buyerBidder?.toString()}>
      {buyerBidder === undefined ? (
        <div />
      ) : buyerBidder?.toBigNumber().gt(new BigNumber(0)) ? (
        <EthAccountButton variant="outlined" address={buyerBidder} addressLength="auto" />
      ) : (
        <Typography variant="caption">None</Typography>
      )}
    </Property>
  )
}

export default BuyerProperty
